import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import moment from 'moment-timezone'
import { FORMATS } from 'constants/datetime'

interface IPackageFilesRowProps {
  deprecatedAt: Maybe<string>
  fileName?: string
  url: Maybe<string>
}

export const PackageFilesDeletedRow: React.FunctionComponent<IPackageFilesRowProps> = React.memo(
  ({ deprecatedAt, fileName, url }) => (
    <div>
      <span>
        <a
          href={url || undefined}
          target='_blank'
          rel='noopener noreferrer'
          data-test='uploaded-docs'>
          {fileName}
        </a>
        <p className='text-secondary'>{moment(deprecatedAt).format(FORMATS.dateFormat)}</p>
      </span>
    </div>
  )
)
